export default __webpack_public_path__ + "8b28abb5406034b241e1e6ccb95603b6.svg";